import reducer, { actions } from './slice';
import * as selectors from './selectors';

export const flashMessageStore = {
  actions,
  selectors,
};

export default reducer;
